// this includes the .
export const getFileExtension = (str: string) =>
  str.slice(str.lastIndexOf("."));

export const getFileNameFromPath = (value: string) =>
  value.substring(value.lastIndexOf("\\") + 1);

export const doesExtensionExist = (value: string) => value.indexOf(".") === -1;
